import { createAction } from '@ngrx/store';
import { HelperMenu } from '../../core/models/HelperMenu';
export const getHelperMenus = createAction('[HelperMenu] Get HelperMenu');
export const addHelperMenu = createAction('[HelperMenu] Add HelperMenu', (helperMenu: HelperMenu) => helperMenu);
export const clearHelperMenu = createAction('[HelperMenu] Clear HelperMenu');
// export const addHelperMenus = createAction('[HelperMenu] Add HelperMenus',(helperMenus: [HelperMenu]) => helperMenus);
